<template>
  <div class="columns is-multiline" v-if="client">
    <div class="column is-12">
      <b-field :label="$t('editionClient.informations.settlementMode')">
        <b-select v-model="client.modeReglementId" expanded>
          <option></option>
          <option v-for="modeReglement in modesReglement"
                  :key="modeReglement.id"
                  :value="modeReglement.id">
            {{modeReglement.libelle}}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field :label="$t('editionClient.informations.settlementPeriod')">
        <b-select v-model="client.delaiReglementId" expanded>
          <option></option>
          <option v-for="delai in delaisReglement"
                  :key="delai.id"
                  :value="delai.id">
            {{delai.libelle}}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-8"
      v-if="delaiReglementPersonnalisable">
      <div class="columns">
        <div class="column is-4">
          <b-field :label="$t('editionClient.informations.dayNumber')">
            <b-input v-model="client.delaiReglementDetail.nombreJourDecalage" >
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
            <b-checkbox v-model="client.delaiReglementDetail.finDeMois" class="elementSansField">
              <span>{{ $t('editionClient.informations.endMonth')}}</span>
            </b-checkbox>
        </div>
        <div class="column is-4">
          <div class="control is-expanded"  v-if="client.delaiReglementDetail.finDeMois">
            <b-field :label="$t('editionClient.informations.dayMonth')">
              <b-select v-model="client.delaiReglementDetail.jourFinDeMois" expanded>
                <option v-for="jour in joursDuMois"
                        :key="jour"
                        :value="jour">
                  {{jour}}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import DELAI_JOUR_MOIS from '@/configuration/parametrage/delaiReglementConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ClientEditInformationsReglements',
  props: ['client'],
  data() {
    return {
      joursDuMois: DELAI_JOUR_MOIS,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    delaisReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.delaiReglement);
    },
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    delaiReglementPersonnalisable() {
      if (!this.client.delaiReglementId) return false;
      const id = this.client.delaiReglementId;
      const delai = this.delaisReglement.find(item => {
        return item.id === id;
      });
      if (!delai) return false;
      return delai.estPersonnalisable;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.delaiReglement,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
